/*
  Превключвател „Продукт / Облечен“ (2026-10-13).
  Сменя <html data-izgled>, помни избора, пази го в адреса (?izgled=oblechen)
  и изпраща събитие към Shopify Analytics и GA4.
*/
(function () {
  if (window.__rbViewToggle) return;
  window.__rbViewToggle = true;

  var KEY = 'rb_izgled';
  var root = document.documentElement;

  function current() {
    return root.dataset.izgled === 'oblechen' ? 'oblechen' : 'produkt';
  }

  function syncButtons() {
    var v = current();
    document.querySelectorAll('.vt-btn').forEach(function (b) {
      b.setAttribute('aria-checked', b.dataset.vt === v ? 'true' : 'false');
      b.tabIndex = b.dataset.vt === v ? 0 : -1;
    });
  }

  function track(v) {
    var data = { izgled: v, page: location.pathname };
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('izgled_snimki', data);
      }
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'izgled_snimki', { izgled: v });
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'izgled_snimki', izgled: v });
      }
    } catch (e) {}
  }

  function setView(v, fromUser) {
    if (v !== 'produkt' && v !== 'oblechen') return;
    if (v === current() && fromUser) return;
    root.dataset.izgled = v;
    try {
      localStorage.setItem(KEY, v);
    } catch (e) {}
    try {
      var url = new URL(location.href);
      url.searchParams.set('izgled', v);
      history.replaceState(history.state, '', url.toString());
    } catch (e) {}
    syncButtons();
    if (fromUser) track(v);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.vt-btn');
    if (!b) return;
    setView(b.dataset.vt, true);
  });

  // Стрелки наляво/надясно, както при радио бутони
  document.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('.vt-btn');
    if (!b) return;
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
    e.preventDefault();
    var next = current() === 'produkt' ? 'oblechen' : 'produkt';
    setView(next, true);
    var target = b.parentElement.querySelector('.vt-btn[data-vt="' + next + '"]');
    if (target) target.focus();
  });

  // Филтрите презареждат решетката – бутоните се синхронизират отново
  var pending = false;
  var grid = document.getElementById('ProductGridContainer') || document.body;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      syncButtons();
    });
  }).observe(grid, { childList: true, subtree: true });

  syncButtons();
})();
